'use strict';
(function () {
    App.filter('filterDeclarationsByStatus', filterDeclarationsByStatus);
    filterDeclarationsByStatus.$inject = [];

    function filterDeclarationsByStatus() {
        return function (declarations, status) {
            if (!status) return declarations;
            var result = angular.copy(declarations);
            angular.forEach(declarations, function (v, k) {
                angular.forEach(v, function (_v, _k) {
                    result[k][_k].declarations = [];
                    angular.forEach(_v.declarations, function (__v) {
                        if (__v.declaration.status === status || status === 'ALL') {
                            result[k][_k].declarations.push(__v);
                        }
                    });
                });
            });
            return result;
        }
    }
})();
